import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initMetaPixel } from "./components/utils/metaPixel";

// Fire the Meta Pixel as early as possible, exactly like Meta's own snippet does.
initMetaPixel();
function addLink(rel: string, href: string, extra: Partial<HTMLLinkElement> = {}): HTMLLinkElement {
  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  Object.assign(link, extra);
  document.head.appendChild(link);
  return link;
}

// Only the 2 origins that actually matter for this page get a preconnect:
// - cdn.magicpatterns.com serves our JS/CSS bundle and the hero image (LCP).
// - fonts.gstatic.com serves the actual font binaries (the heaviest hop).
// We deliberately skip fonts.googleapis.com: the preload tag below already
// opens that connection, so a second preconnect to it just sits unused.
addLink("preconnect", "https://cdn.magicpatterns.com");
addLink("preconnect", "https://fonts.gstatic.com", {
  crossOrigin: "anonymous"
});

// Load Google Fonts without blocking the initial render: fetch the stylesheet
// as a low-priority preload, then flip it to an active stylesheet once ready.
// `display=swap` in the URL keeps text visible in a fallback font while it loads.
// This keeps the font request off the critical rendering path entirely.
const fontsHref = "https://fonts.googleapis.com/css2?family=Oswald:wght@600;700&family=Inter:wght@400;500;600;700&display=swap";
const fontPreload = addLink("preload", fontsHref, {
  as: "style"
});
fontPreload.onload = () => {
  fontPreload.onload = null;
  fontPreload.rel = "stylesheet";
};
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-381" data-mp="1enjuxgfvoz6t" />);
}